<template>
  <div class="text-center max-w-xl">
    <!-- Title -->
    <h1 class="text-4xl text-gray-900 mb-4">
      Payment Failed
    </h1>

    <!-- Error Message -->
    <p class="text-gray-600 mb-10">
      {{ message }}
    </p>

    <!-- Try Again Button -->
    <button
      @click="$emit('retry')"
      class="inline-flex items-center justify-center px-10 py-4 bg-gray-900 text-white text-lg font-medium rounded-full hover:bg-gray-800 transition-all duration-200 shadow-lg"
    >
      Try Payment Again
    </button>
  </div>
</template>

<script setup lang="ts">
interface Props {
  message: string
}

defineProps<Props>()

defineEmits<{
  retry: []
}>()
</script>
